import { z } from 'zod';
/**
 * Read-aloud: 'auto' says each question as it appears, 'tap' only when the
 * speaker is tapped, 'off' hides the speaker.
 */
export const READ_ALOUD_MODES = ['auto', 'tap', 'off'];
export const readAloudSchema = z.enum(READ_ALOUD_MODES);
/** Who is not yet reading for themselves hears the question without asking. */
const READ_TO_BY_DEFAULT = ['Pre-Prep', 'Prep'];
/**
 * The parent's choice, or - when they have not made one - the default for the
 * child's year. Unset rather than stored, so a child moving up a year moves to
 * that year's default.
 */
export function readAloudFor(settings, yearLevelLabel) {
    return settings.readAloud ?? (READ_TO_BY_DEFAULT.includes(yearLevelLabel) ? 'auto' : 'tap');
}
/**
 * Exactly what the device says for a question - shared so the audit sheet
 * prints the same words the iPad speaks.
 */
export function sayable(speak) {
    // The server already strips emoji. A synthesiser reads an emoji's NAME
    // ("red circle"), so this is the belt to that pair of braces.
    const clean = (s) => s
        .replace(/\p{Extended_Pictographic}/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    const options = (speak.choices ?? []).map(clean).filter((c) => c !== '');
    let text = clean(speak.text);
    // The options are a new sentence; a question that ends without one gets it.
    if (options.length > 0 && !/[.?!]$/.test(text))
        text = `${text}.`;
    if (options.length === 1)
        text += ` Is it ${options[0]}?`;
    if (options.length > 1) {
        text += ` Is it ${options.slice(0, -1).join(', ')} or ${options[options.length - 1]}?`;
    }
    return text;
}
//# sourceMappingURL=read-aloud.js.map